import {
  ADD_LEADS_LIST,
  GET_LEADS_LIST,
  UPDATE_LEADS_LIST,
  DELETE_LEADS_LIST,
} from "../types/leads-list";

export const getList = (params) => ({
  type: GET_LEADS_LIST,
  payload: params,
});

export const addList = (params) => ({
  type: ADD_LEADS_LIST,
  payload: params,
});

export const updateList = (params) => ({
  type: UPDATE_LEADS_LIST,
  payload: params,
});
export const deleteList = (params) => ({
  type: DELETE_LEADS_LIST,
  payload: params,
});
